import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { Typography } from "@parkschannel/ui";
import { UserPublicProfile } from "../../UserProfile/UserPublicProfile";
import { useVideoModalContext, VideoModal } from "../../Video";
import { useUserVideos, BeLikeUserBanner, UserVideoListWithPagination } from "../../UserProfile";
import { InitialPaginationContext, usePaginationQuery, useScrollTo } from "../../../utils";
export const UserPublicProfileVideosPage = (param)=>{
    let { query: { id  } , initialPagination  } = param;
    const { useUserVideosQuery  } = useUserVideos();
    const { data: videos , pagination  } = usePaginationQuery((paginationParams)=>useUserVideosQuery(id, paginationParams), {
        initialPagination
    });
    return /*#__PURE__*/ _jsx(UserPublicProfile, {
        id: id,
        children: (user)=>!videos || !videos.data || videos.data.length === 0 ? /*#__PURE__*/ _jsx(PageWithoutVideos, {}) : /*#__PURE__*/ _jsxs(InitialPaginationContext.Provider, {
                value: {
                    initialPagination
                },
                children: [
                    /*#__PURE__*/ _jsx(PageWithVideos, {
                        videos: videos,
                        pagination: pagination
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "mt-6 md:mt-10 lg:mt-[72px]",
                        children: /*#__PURE__*/ _jsx(BeLikeUserBanner, {
                            userName: user.name
                        })
                    })
                ]
            })
    });
};
const PageWithVideos = (param)=>{
    let { videos , pagination  } = param;
    const { scrollTo  } = useScrollTo({
        id: "user-videos-section"
    });
    const { setSelectedVideo , selectedVideo  } = useVideoModalContext();
    return /*#__PURE__*/ _jsxs("div", {
        className: "w-full",
        id: "user-videos-section",
        children: [
            /*#__PURE__*/ _jsx(UserVideoListWithPagination, {
                data: videos.data,
                onPageChange: scrollTo,
                pagination: pagination
            }),
            /*#__PURE__*/ _jsx(VideoModal, {
                isOpen: !!selectedVideo,
                setIsOpen: ()=>setSelectedVideo(null)
            })
        ]
    });
};
const PageWithoutVideos = ()=>{
    return /*#__PURE__*/ _jsx(Typography, {
        variant: "h6",
        component: "h2",
        className: "!font-medium text-neutral-900 mb-12 text-center",
        children: "This user has not added any videos yet..."
    });
};
